
import { RouteLocationNormalized } from 'vue-router'

import { useChatMessageStore } from '@/entities/messages'

import { isNotPServed, toPServedUser } from '@/shared/utils/uri'

export const beforeEnterChatPageSafe = async (to: RouteLocationNormalized): Promise<void> => {
  try {
    const { id: chatIdParam } = to.params
    let chatRouteId

    if (Array.isArray(chatIdParam)) {
      chatRouteId = chatIdParam[0]
    } else {
      chatRouteId = chatIdParam
    }
    const roomId = atob(chatRouteId!)
    const pServed = isNotPServed(roomId) ? toPServedUser(roomId, true) : roomId
    await useChatMessageStore().prefetchHistory(pServed)
  } catch (e) {
    console.error(e)
  }
}
